import { ChildModel, ModelBase } from 'store/model-base';

import { LineDetail } from './detail';
import { LineDevice } from './device';

export class LineCollection extends ModelBase {
    public static storeName: string = 'lineCollection';
    public static colors: string[] = [ '#50c3d5', '#7155d3', '#ff9271', '#ffd871', '#65d0a7', '#bc43d3', '#fb543f', '#ffa700', '#1ee2c9', '#0e8751' ];

    public lines: LineDetail[];
    public haveRfaLines: boolean;
  
    public static create<T extends ModelBase>(initData: object): T {
        const toReturn: LineCollection = super.create<LineCollection>(initData);

        // assign colors to the icon letter
        let colorIndex: number = 0;

        for (const line of toReturn.lines) {
            colorIndex = colorIndex === LineCollection.colors.length ? 0 : colorIndex;

            line.color = LineCollection.colors[colorIndex++];

        }

        toReturn.haveRfaLines = Boolean(toReturn.lines.find((line: LineDetail) => line.canActivate));

        /* eslint-disable @typescript-eslint/no-explicit-any */
        return <T> <any> toReturn;
        /* eslint-enable @typescript-eslint/no-explicit-any */
    }

    protected static get hasMany(): ChildModel[] {
        return [{
            attrName: 'lines',
            model: LineDetail
        }];
    }

    public get cancelEligibileLines(): LineDetail[] {
        return this.lines.filter((line: LineDetail) => line.isActive);
    }

    public get byTheGigLines(): LineDetail[] {
        return this.lines.filter((line: LineDetail) => !line.isUnlimited);
    }

    public get unlimitedLines(): LineDetail[] {
        return this.lines.filter((line: LineDetail) => line.isUnlimited);
    }

    public get linesWithActiveDevices(): LineDetail[] {
        return this.lines.filter((line: LineDetail) => line.activeDevice);
    }

    public get activeDevices(): LineDevice[] {
        return this.lines.map((line: LineDetail) => line.activeDevice);
    }

    /**
     * get Line By ID
     * @param id id.value from Line Summary
     */

    public getLineByValue(value: string): LineDetail {
        return this.lines.find((line: LineDetail) => line.id.value === value);
    }

    /**
     * get Line By KEY
     * @param id id.key from Line Summary
     */

    public getLineByKey(key: string): LineDetail {
        return this.lines.find((line: LineDetail) => line.id.key === key);
    }

    /**
    * get Line By Device IMEI
    * @param imei from Line Device imei
    */

    public getLineByDeviceImei(imei: string): LineDetail {
        return this.lines.find((line: LineDetail) => line.devices.find((device: LineDevice) => device.imei === imei));
    }

    /**
    * get Line By Device tradeinOfferId
    * @param tradeinOfferId from Line Device tradeinOfferId
    */

    public getLineByDeviceOfferId(tradeinOfferId: string): LineDetail {
        return this.lines.find((line: LineDetail) => line.devices.find((device: LineDevice) => device.subsidy && device.subsidy.tradeinOfferId === tradeinOfferId));
    }

    /**
    * get Line By Upgrade OfferId
    * @param offerId from Line tradeInDetails offerId
    */

    public getLineByOfferId(offerId: string): LineDetail {
        return this.lines.find((line: LineDetail) => line.tradeInDetails && line.tradeInDetails.offerId === offerId);
    }
}
